import { render } from "./Presses.vue?vue&type=template&id=0b95bb7e&scoped=true"
import script from "./Presses.vue?vue&type=script&lang=js"
export * from "./Presses.vue?vue&type=script&lang=js"

import "./Presses.vue?vue&type=style&index=0&id=0b95bb7e&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b95bb7e"]])

export default __exports__